import { productType } from "@website/ticket-ui/common/constants/values";
import { FunnelStorageSDK } from "@website/tracking/storage";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import {
  DomFlightTrackingTypes,
  IntFlightTrackingTypes
} from "@website/tracking/types";

export const addSearchBoxInteractedTrackingEvent = (
  parameters: Partial<DomFlightTrackingTypes | IntFlightTrackingTypes>
) => {
  FunnelStorageSDK.addEventToTrackingFunnel(
    USER_TRACKING_EVENTS.SEARCH_BOX_INTERACTED,
    productType === "dom-flight" ? "dom-flight" : "int-flight",
    parameters
  );
};
